import { Token } from '@kodiak-finance/sdk-core'
import { Pool, Position } from '@kodiak-finance/v3-sdk'
import { SupportedChainId } from 'config/chains'
import { PortfolioV3PositionFieldsFragment } from 'queries/v3/generated'

export function buildV3Position(
  subgraphPosition: PortfolioV3PositionFieldsFragment,
  chainId: SupportedChainId
): Position {
  // Create Token instances
  const token0 = new Token(
    chainId,
    subgraphPosition.token0.id,
    parseInt(subgraphPosition.token0.decimals),
    subgraphPosition.token0.symbol,
    subgraphPosition.token0.name
  )

  const token1 = new Token(
    chainId,
    subgraphPosition.token1.id,
    parseInt(subgraphPosition.token1.decimals),
    subgraphPosition.token1.symbol,
    subgraphPosition.token1.name
  )

  // Create Pool instance
  const pool = new Pool(
    token0,
    token1,
    parseInt(subgraphPosition.pool.feeTier),
    subgraphPosition.pool.sqrtPrice,
    subgraphPosition.pool.liquidity,
    parseInt(subgraphPosition.pool.tick || '0')
  )

  // Create Position instance
  const position = new Position({
    pool,
    liquidity: subgraphPosition.liquidity,
    tickLower: parseInt(subgraphPosition.tickLower.tickIdx),
    tickUpper: parseInt(subgraphPosition.tickUpper.tickIdx),
  })

  return position
}
